<template>
  <ap-sider-title
    class="mb-1 mt-3 min-h-9 md:min-h-7 font-normal"
    :title="$t('navigation.project.label')"
    button
    @action="handleCreateProject()" />
  <ap-sider-item
    :selected="false"
    class="mb-1 min-h-9 md:min-h-7 font-normal"
    :icon="PlusOutlined"
    :text="$t('component.button.create.project.label')"
    @click="handleCreateProject()"
    v-if="!projects.length" />
  <ap-sider-item
    v-for="(project, key) in projects"
    :key="key"
    :selected="targetProject?.uuid === project.uuid"
    class="mb-1 min-h-9 md:min-h-7 font-normal project-item"
    :icon="FolderOutlined"
    :text="project.title"
    @click="onClickProjectItem(project)" />
  <CreateProjectModal v-model:open="isOpenCreateModal" v-if="isOpenCreateModal" />
</template>

<script setup>
import { storeToRefs } from "pinia"
import { onBeforeMount } from "vue"
import { useRouter } from "vue-router"
import { FolderOutlined, PlusOutlined } from "@ant-design/icons-vue"
import CreateProjectModal from "@/components/Projects/CreateProjectModal.vue"
import CreateProjectHandler from "@/handlers/Project/CreateProjectHandler"
import { useProjectsStore } from "@/stores/projects"

const { isOpenCreateModal, projects, targetProject } = storeToRefs(useProjectsStore())
const router = useRouter()

function handleCreateProject() {
  CreateProjectHandler.render()
}
function onClickProjectItem(project) {
  router.push({ name: "project", params: { uuid: project.uuid } })
}

onBeforeMount(() => useProjectsStore().fecthProjects())
</script>

<style lang="postcss">
.project-item {
  span:last-of-type {
    @apply w-[calc(100%-1rem)] text-ellipsis whitespace-nowrap overflow-hidden text-left;
  }
  span:last-of-type::first-letter {
    @apply uppercase;
  }
}
</style>
